import { bugfix, featureChange, newFeature, Version, version } from './types'

const changelog_dev: Array<Version> = [
  version('6.23.0-beta-1', '2026-11-04T15:30', [
    featureChange(
      'Pohjolan Liikenne',
      'Lisätty NFC-tagin sarjanumero bussinkuljettajien työvuorolle kirjautumiseen.'
    ),
  ]),
  version('6.22.0-beta-10', '2026-10-28T10:00', [
    featureChange(
      'Vika-apuri',
      'Jos AI-laatutarkistus ei ole saatavilla, niin vikailmoituksen lisääminen onnistuu ilman sitä.'
    ),
    featureChange('Vika-apuri', 'Tehty vika-apurin loppuvaiheesta sujuvampi.'),
  ]),
  version('6.22.0-beta-8', '2026-10-23T10:00', [
    featureChange('Vika-apuri', 'Vika-apuriin lisätty <AI> tägi.'),
  ]),
  version('6.22.0-beta-7', '2026-10-22T16:00', [
    featureChange('Vika-apuri', 'Vika-apuriin tehty muutoksia.'),
  ]),
  version('6.22.0-beta-3', '2026-10-20T10:00', [
    bugfix(
      'Vuoro- ja vuorolistapalautteet',
      'Vuoro- ja vuorolistapalautteiden taustajärjestelmä vaihdettu. Vastaukset palautteisiin tulevat nyt muuta kautta.'
    ),
  ]),
  version('6.22.0-beta-2', '2026-10-19T09:00', [
    bugfix('Kulkutietiojen raidetiedot', 'Palautettu kulkutietiojen raidetiedot työvuoronäkymään.'),
  ]),
  version('6.22.0-beta-1', '2026-10-16T13:30', [
    featureChange(
      'Siirtotehtävien raiteet',
      'Logistiikan Riihimäen siirtotehtäviltä poistettu harhaanjohtavat raidetiedot.'
    ),
  ]),
  version('6.21.0-beta-5', '2026-10-02T15:00', [
    featureChange(
      'Lähiliikenteen työvuorot',
      'Lisätty lähiliikenteen vuoroille alku- ja loppuasemat kalenterinäkymään.'
    ),
  ]),
  version('6.21.0-beta-4', '2026-10-02T14:30', [
    featureChange(
      'Ylläpito',
      'Poistettu koodista vanhentuneet rajapinnat liitteiden lisäykseen ja vikailmoitusten hakuun.'
    ),
  ]),
  version('6.21.0-beta-1', '2026-09-25T16:00', [
    featureChange(
      'Palvelurajoitteet',
      'Lisätty checkboxi, jolla voi piilotta palvelurajoitteiset viat.'
    ),
  ]),
  version('6.21.0-beta-1', '2026-09-25T12:00', [
    featureChange(
      'Ajotietotulosteet',
      'Ajotietotulosteen voi nyt saada myös työvuorolle, jossa on tehtäviä, joille ajotietotulostetta ei voida hakea.'
    ),
  ]),
  version('6.20.0-beta-1', '2026-09-07T16:00', [
    bugfix(
      'Kenttä-sovellus',
      'Korjattu ongelma, jossa puhelimen yläpalkki kelloineen menee piiloon Kenttä-sovellusta käytettäessä.'
    ),
  ]),
  version('6.18.0-beta-9', '2026-08-10T10:30', [
    bugfix(
      'Kulkutietojen haastot',
      'Korjattu ongelma, jossa kulkutietojen haastot sivulta häviää haaston tiedot jos sivun päivittää.'
    ),
    bugfix(
      'Myöhästymisilmoitukset',
      'Korjattu myöhästymisilmoitukset käyttämään oikean tyypin mukaista syytä myöhästymiselle.'
    ),
  ]),
  version('6.18.0-beta-8', '2026-08-06T10:30', [
    featureChange(
      'Työvuoronäkymä',
      'Lisätty kaukoliikenteen työvuoronäkymään myöhästymisilmoitukset junan kalustovioista.'
    ),
  ]),
  version('6.18.0-beta-6', '2026-07-31T09:30', [
    featureChange(
      'Kulkutietojen haku',
      'Kulkutietojen hakeminen on siirretty Digitrafficin rajapinnasta Myllyn rajapintaan.'
    ),
  ]),
  version('6.18.0-beta-5', '2026-07-30T12:30', [
    featureChange('Henkilökuntahaku', 'Lisätty viivat käyttäjäroolien väliin henkilökuntahaussa.'),
  ]),
  version('6.18.0-beta-4', '2026-07-29T10:30', [
    featureChange('Vika-apuri', 'Parannettu vika-apurin yönäkymän tyylejä'),
  ]),
  version('6.18.0-beta-3', '2026-07-27T13:30', [
    bugfix('Vika-apuri', 'Parannettu vika-apurin tekstien luettavuutta yönäkymässä.'),
  ]),
  version('6.18.0-beta-2', '2026-07-27T08:30', [
    featureChange(
      'Vikailmoitusten lisäys',
      'Lisätty tuki suuremmille liitetiedostoille vikailmoituksissa.'
    ),
    featureChange(
      'Vika-apuri',
      'Vika-apurin kautta tehtäville vikailmoituksille lisätty palvelurajoitteet.'
    ),
  ]),
  version('6.18.0-beta-1', '2026-07-21T16:30', [
    featureChange(
      'Vika-apuri',
      'Parannettu näkymää, joka näytetään, kun vika-apuri ei löydä sopivia vikakoodeja.'
    ),
    featureChange(
      'Vika-apuri',
      'Muokattu vika-apurin toimintaa niin, että vikailmoitusta täytettäessä voi palata aiempiin valintoihin.'
    ),
    bugfix(
      'Vika-apuri',
      'Muutettu vika-apurin toimintaa niin, että hylätyt valinnat eivät enää näy vikailmoitusta täytettäessä.'
    ),
    bugfix(
      'Vikailmoitusten lisäys',
      'Korjattu ongelma, jossa liitetiedostot eivät poistuneet, jos vikailmoituksen lisääminen keskeytettiin.'
    ),
  ]),
  version('6.17.0-beta-2', '2026-07-02T12:00', [
    newFeature(
      'Käyttäjäryhmät',
      'Pohjolan Liikenteen toimihenkilöille on lisätty uusi käyttäjäryhmä Kenttään.'
    ),
    featureChange(
      'Työvuoronäkymä',
      'Tehostettu työvuoron tehtävien energiankulutustietojen hakua.'
    ),
  ]),
  version('6.17.0-beta-1', '2026-07-01T15:00', [
    newFeature(
      'Työvuoronäkymä',
      'Lisätty uusi kommenttikenttä, joka sisältää lisätietoja tehtävästä lähiliikenteen tehtäväkorteille.'
    ),
  ]),
  version('6.16.0-beta-1', '2026-06-26T14:00', [
    bugfix(
      'Työvuoronäkymä',
      'Korjattu ongelma, jossa lähiliikenteen työvuorot eivät avaudu, jos ne sisältävät kiellettyjä merkkejä.'
    ),
    bugfix('Työvuoronäkymä', 'Korjattu työvuoronäkymässä bussiväleillä näkyvä tehtävän nimi.'),
  ]),
  version('6.15.3-beta-1', '2026-06-17T17:30', [
    newFeature(
      'Bussinkuljettajien työvuorokirjautuminen',
      'Lisätty taulukko bussinkuljettajien työvuorokirjautumisista, joka näyttää viimeisimmät kirjautumiset.'
    ),
  ]),
  version('6.15.0-beta-9', '2026-06-12T14:00', [
    featureChange(
      'Vikailmoitusten selaus',
      'Muokattu omien vikailmoitusten selauksessa käytettävän valitsimen tekstejä.'
    ),
  ]),
  version('6.15.0-beta-8', '2026-06-12T13:00', [
    newFeature(
      'Vikailmoitusten selaus',
      'Lisätty omien vikailmoitusten selaukseen mahdollisuus valita, kuinka monta vikailmoitusta näytetään.'
    ),
    featureChange(
      'Kokoonpanonäkymä',
      'Lisätty lähiliikenteen kuljettajille oikeus hakea junien kokoonpanotietoja.'
    ),
  ]),
  version('6.15.0-beta-7', '2026-06-11T08:00', [
    newFeature(
      'Yhdistelmäversio',
      'Yhdistetty vika-apurin ja bussikuljettajien työvuorokirjautumisen tuoreimmat versiot.'
    ),
  ]),
  version('6.15.0-beta-6', '2026-06-11T14:00', [
    newFeature(
      'Bussinkuljettajien työvuorokirjautuminen',
      'Lisätty ominaisuus, joka ohjaa käyttäjän NFC-asetuksiin, jos NFC ei ole käytössä.'
    ),
  ]),
  version('6.15.0-beta-5', '2026-06-11T10:00', [
    newFeature(
      'Vika-apuri suorituskykyparannus',
      'Vikailmoitusapurin ensimmäisen suosituksen suorituskykyä parannettu näyttämällä vikakoodit nopeammin.'
    ),
  ]),
  version('6.15.0-beta-3', '2026-06-08T10:00', [
    newFeature(
      'Mylly.AI vika-apuri 1.0.0-beta-2',
      'Mylly.AI vika-apuri muokattu helppokäyttöisemmäksi ja selkeämmäksi.'
    ),
  ]),
  version('6.15.0-beta-2', '2026-06-05T08:00', [
    newFeature('Mylly.AI vika-apuri 1.0.0-beta-1', 'Parannettu versio Mylly.AI vika-apurista'),
  ]),
  version('6.14.0-beta-2', '2026-05-29T15:00', [
    newFeature(
      'Mylly.AI vika-apuri',
      'Luotu alustava versio Mylly.AI vika-apurista, muuttaa vianluonnin workflow:ta'
    ),
  ]),
  version('6.14.0-beta-1', '2026-05-27T13:00', [
    newFeature(
      'Pohjolan liikenne',
      'Lisätty NFC vuorolle kirjautuminen pohjolan liikenteen bussikuskeille.'
    ),
  ]),
  version('6.13.0-beta-2', '2026-05-12T08:00', [
    bugfix(
      'Sm-liikenteen merkittävät häiriötilanteet',
      'Korjattu ongelma, jossa sivun päivitys aiheutti käyttäjän uloskirjautumisen.'
    ),
  ]),
  version('6.12.0-beta-2', '2026-04-30T09:00', [
    bugfix('Työvuoronäkymä', 'Muutettu kokoonpanopainikkeen näkyvyyttä lähiliikenteen junille.'),
  ]),
  version('6.12.0-beta-1', '2026-04-29T15:00', [
    featureChange(
      'Työvuoronäkymä',
      'Lisätty kalustonumeroiden haku junille joilla ei ole kalustonumeroita työvuoronäkymässä'
    ),
    bugfix('Työvuoronäkymä', 'Korjattu lähiliikenteen työvuoronäkymässä vetokaluston tiedot'),
  ]),
  version('6.11.0-beta-2', '2026-04-22T13:45', [
    bugfix(
      'Virheenkäsittely',
      'Korjattu ongelma, joka johti käyttöä rajoittaviin virheilmoituksiin Kentässä.'
    ),
  ]),
  version('6.11.0-beta-1', '2026-04-16T17:00', [
    featureChange(
      'Vikailmoitusten kommentointi ja selaus',
      'Muutettu tekstien järjestystä vikailmoituksissa ja yleistä ulkoasua parannettu.'
    ),
    featureChange(
      'Vikailmoitusten lisäys',
      'Lisätty logistiikan kuljettajille mahdollisuus lisätä vikailmoituksia'
    ),
  ]),
  version('6.10.0-beta-10', '2026-04-15T15:30', [
    featureChange(
      'Työvuoronäkymä ja hakutoiminnot',
      'Poistettu konduktööreiltä ja junatarjoilijoilta oikeus ajotietotulosteen lataukseen.'
    ),
    bugfix(
      'Junaluntti',
      'Korjattu junalunttiin liittyvät tekstit vastaamaan paremmin junaluntin tarkoitusta ja sisältöä'
    ),
  ]),
  version('6.10.0-beta-6', '2026-04-08T08:20', [
    featureChange(
      'Työvuoronäkymä',
      'Lisätty työvuoronäkymään ilmoitus jos vaunuilla on käyttörajoitteita'
    ),
    bugfix(
      'Vikailmoitusten kommentointi ja selaus',
      'Muokattu vikailmoituksissa näkyvää käyttäjän roolin tekstiä'
    ),
  ]),
  version('6.10.0-beta-5', '2026-04-01T15:00', [
    bugfix(
      'Käyttörajoitteet',
      'Korjattu käyttörajoitteet sivulla ilmoita uusi vika painike pysymään näkyvillä välilehteä vaihtaessa'
    ),
  ]),
  version('6.10.0-beta-4', '2026-04-01T10:30', [
    bugfix(
      'Vikailmoitusten kommentointi ja selaus',
      'Korjattu kommenttien haku ja näyttäminen vikailmoituksille'
    ),
  ]),
  version('6.10.0-beta-2', '2026-03-31T15:50', [
    newFeature(
      'Vikailmoitusten kommentointi ja selaus',
      'Vikailmoitukset sivulle omat ilmoitukset näkymä ja vikojen kommentointi'
    ),
  ]),
  version('6.10.0-beta-1', '2026-03-31T13:00', [
    bugfix(
      'Attendance työvuoroille ilmottautuminen',
      'Lisätty lähiliikenteen attendance työvuoroille ilmottautuminen. Lisäksi jos ilmoittautuu työvuorolle ja seuraava(t) työvuoro(t) ovat <5min päässä edellisen lopusta, järjestelmä ilmoittaa automaattisesti myös niille.'
    ),
  ]),
  version('6.9.0-beta-5', '2026-03-30T12:00', [
    bugfix(
      'Runkokiertojen virheelliset kellonajat',
      'Korjattu runkokierroissa näytetyt virheelliset kellonajat'
    ),
  ]),
  version('6.9.0-beta-4', '2026-03-27T10:00', [
    bugfix(
      'Liito-häiriöviestit',
      'Liito-häiriöviestit eivät vaihda sivua heti saapuessa, vaan vasta jos ilmoitusta klikataan'
    ),
  ]),
  version('6.9.0-beta-3', '2026-03-24T14:00', [
    bugfix(
      'Työvuoron tiedot',
      'Palvelurajoitteet eivät näy kuljettajalle keltaisena nappina työvuorossa'
    ),
  ]),
  version('6.9.0-beta-2', '2026-03-23T15:30', [
    bugfix(
      'Etusivu',
      'Vähennetty ylimääräistä tyhjää tilaa järjestyksenvalvojien ja huoltohenkilökunnan etusivulla'
    ),
  ]),
  version('6.9.0-beta-1', '2026-03-20T10:30', [
    bugfix('Työvuoroluettelo', 'H+ päivät näkyvät työvuoroluettelossa.'),
  ]),
  version('6.8.0-beta-2', '2026-03-06T11:00', [
    bugfix(
      'Kulkutietojen haastot',
      'Korjattu vika, joka esti kulkutietojen haastojen klikkaamisen auki'
    ),
  ]),
  version('6.8.0-beta-1', '2026-03-04T11:30', [
    bugfix(
      'Työvuoropalautteen lomakkeesta puuttuu käännös päättymisajalle',
      'Lisätty puuttuva käännös työvuoropalautteen lomakkeelle'
    ),
  ]),
  version('6.7.0-beta-8', '2026-02-27T12:30', [
    newFeature(
      'KEN-1831: junaluntti',
      'Kulkutiedot sivulle lisätty junalunttia korvaava vaunukiertonäkymä'
    ),
  ]),
  version('6.7.0-beta-7', '2026-02-23T12:30', [
    bugfix(
      'Henkilöstön näkyminen henkilöstöhaussa',
      'Korjattu bugi jossa käyttäjä ei nähnyt itseään henkilöstössä, mikäli käyttäjän henkilönumero oli 7 merkkiä pitkä. Nyt kaikki käyttäjät näkevät myös itsensä henkilöstössä.'
    ),
  ]),
  version('6.7.0-beta-4', '2026-02-02T15:30', [
    bugfix(
      'Lähiliikenteen työvuorokirjautuminen',
      'Lähiliikenteen työvuorilla ei näytetä vuoropalautetta, vaikka käyttäjä olisi kirjautunut vuorolle Kentässä.'
    ),
  ]),
  version('6.7.0-beta-3', '2026-01-26T14:30', [
    featureChange(
      'Ohjus viestit',
      'Ohjus viesteille näytetään lähettäjäryhmä myös tapahtumat-osiossa ja näytön alareunassa.'
    ),
  ]),
  version('6.7.0-beta-1', '2026-01-21T14:30', [
    bugfix(
      'Lähiliikenteen työvuorokirjautuminen',
      'Kirjautumisnappi näkyy nyt myös etusivulla lähiliikenteen kuljettajille.'
    ),
  ]),
  version('6.6.0-beta-2', '2026-01-19T12:30', [
    featureChange(
      'Ohjus viestit',
      'Ohjus viesteille näytetään lähettäjäryhmä jos tieto on saatavilla.'
    ),
  ]),
  version('6.5.0-beta-9', '2026-01-13T10:30:00', [
    bugfix('Huoltotyötilaukset', 'Korjattu kalustonumero-kentän ja hakunapin päällekäisyys.'),
    featureChange(
      'Vikailmoitukset',
      "'Rekisteröity'-tilassa oleville vioille näytetään luontiajankohta."
    ),
  ]),
  version('6.5.0-beta-8', '2026-01-12T16:30:00', [
    featureChange(
      'Lähiliikenteen työvuorot',
      'Lähiliikenteen kuljettajat voivat nyt ilmoittautua työvuoroihin Kentässä.'
    ),
  ]),
  version('6.5.0-beta-7', '2026-01-09T16:30:00', [
    featureChange(
      'Kokoonpanonäkymä',
      'Kokoonpanonäkymässä näkyy nyt varoitus, jos kalusto on hinauksessa.'
    ),
    bugfix(
      'Tehtäväkortin hinausvaroitukset',
      'Tehtäväkortilla ei enää näy kaksi kertaa sama hinausvaroitus sm3 ja sm6 kalustoille.'
    ),
    bugfix(
      'Kaukoliikenteen ilmoitustaulu',
      'Kaukoliikenteen ilmoitustaulun nimi ja linkki vaihdettu, sekä lisätty kriittisyysvärit.'
    ),
  ]),
  version('6.5.0-beta-6', '2026-01-07T15:30:00', [
    featureChange(
      'Tehtäväkortin runkokierrot',
      'Tehtäväkortin Myllystä ja CE:stä tuleville runkokierroille näkyy nyt aikataulupallerot.'
    ),
    newFeature(
      'Kaukoliikenteen ilmoitustaulu',
      'Kaukoliikenteen ilmoitustaulu otettu käyttöön konduktööreille ja junatarjoilijoille.'
    ),
  ]),
  version('6.5.0-beta-5', '2025-12-29T13:00:00', [
    bugfix('Vikailmoittaminen', 'Korjattu vikailmoitusten korjaus-aikaleiman muotoilu.'),
  ]),
  version('6.5.0-beta-4', '2025-12-19T16:00:00', [
    featureChange(
      'Runkokierrot',
      'Logistiikan kuljettajille haetaan nyt runkokierrot Myllystä ja CE:stä, ja ne sisältävät myös vetokalustot.'
    ),
    featureChange('Vikaikonit', 'Käyttörajoitteellisten vikojen ikonia korostettu.'),
    bugfix(
      'Lähiliikenteen henkilökuntahaku',
      'Lähiliikenteen henkilökuntahaussa tulee nyt kaikki henkilöt.'
    ),
  ]),
  version('6.5.0-beta-3', '2025-12-15T16:00:00', [
    bugfix(
      'Ajotietotulosteet',
      'Tehtävän ajotietotulosta hakee nyt oikean päivän ajotietotulosteen yön yli kulkeville junille. Lisäksi nämä tulosteet ovat myös rajattu vain kyseiselle tehtävälle.'
    ),
  ]),
  version('6.5.0-beta-2', '2025-12-15T11:00:00', [
    newFeature(
      'Palvelurajoitteet',
      'Lisätty tuki palvelurajoitteen lisäämiselle vikailmoitukseen.'
    ),
  ]),
  version('6.3.2-beta-1', '2025-11-19T14:00:00', [
    newFeature(
      'Lähiliikenteen järjestyksenvalvojat',
      'Lisätty AD-ryhmä lähiliikenteen järjestyksenvalvojille.'
    ),
    featureChange(
      'Vikaikonit',
      '3-tason vikojen ikonit ovat nyt keltaisia jos vialla on käyttörajoite.'
    ),
  ]),
  version('6.3.0-beta-5', '2025-11-11T10:00:00', [
    featureChange(
      'Työvuorohaku',
      'Työvuorohaku piilotettu lähiliikenteen kuljettajilta ja konduktööreiltä.'
    ),
  ]),
  version('6.2.0-beta-4', '2025-10-30T16:00:00', [
    featureChange('Henkilökuntahaku', 'Kaikki käyttäjät näkevät nyt koko junan henkilökunnan.'),
    featureChange('Energiatehokkuuden yhteenveto', 'Etusivun yhteenvedon selitteitä parannettu.'),
  ]),
  version('6.2.0-beta-2', '2025-10-30T16:00:00', [
    newFeature('Radalla-viestit', 'Radalla-viestit laitettu päälle logistics_driver käyttäjille.'),
    newFeature('Lovi', 'Veksi vaihdettu Loviin.'),
  ]),
  version('6.2.0-beta-1', '2025-10-29T12:30:00', [
    newFeature(
      'Lähiliikenteen järjestyksenvalvojat',
      'Listätty lähiliikenteen järjestyksenvalvojat.'
    ),
  ]),
  version('6.1.0-beta-6', '2025-10-17T13:00:00', [
    featureChange('Kokoonpanonäkymä', 'Tiivistetty kokoonpanonäkymän vikalistauksen rakennetta.'),
  ]),
  version('6.1.0-beta-5', '2025-10-17T13:00:00', [
    featureChange(
      'Kokoonpanonäkymä',
      'Kokoonpanonäkymän vikalistauksessa viat on nyt järjestetty kriittisyyden mukaan.'
    ),
    featureChange(
      'Vian ilmoittaminen',
      'Tehtäväkortin vikailmoitus avaa nyt suoraan vikailmoituslomakkeen tehtävän kalustot korostettuna.'
    ),
  ]),
  version('6.1.0-beta-4', '2025-10-13T16:30:00', [
    newFeature(
      'Vikailmoituslomake',
      'Sallittu vikailmoituslomakken käyttö lähiliikenteen henkilökunnalle ja parannettu ohjetekstejä.'
    ),
  ]),
  version('6.1.0-beta-1', '2025-10-02T10:15:00', [
    newFeature(
      'Junan viat välilehti kokoonpanonäkymään',
      'Lisätty junan viat välilehti kokoonpanot näkymään.'
    ),
  ]),
  version('6.0.0-beta-15', '2025-09-26T14:00:00', [
    bugfix(
      'Työvuorojen kokoonpanohaku',
      'Korjattu työvuorojen kokoonpanonappi aktiiviseksi myös junille, joilla ei ole operatingDate tietoa.'
    ),
  ]),
  version('6.0.0-beta-8', '2025-09-15T15:20:00', [
    bugfix(
      'Pääkäyttäjän roolityökalu',
      'Korjattu Act-as työkaluun liittyvä laitehallinta bugi, jonka myötä Kenttä loi aina uuden laitteen assumoinnin yhteydessä.'
    ),
  ]),
  version('6.0.0-beta-7', '2025-09-08T13:00:00', [
    newFeature('Pääkäyttäjän roolityökalu', 'Act-As työkalun laajennus roolikohtaiseksi.'),
  ]),
  version('6.0.0-beta-6', '2025-08-22T15:30:00', [
    featureChange('Yleinen', 'Kovakoodatut linkit ja puhelinnumerot siirretty Contentfuliin.'),
  ]),
  version('6.0.0-beta-4', '2025-08-21T11:30:00', [
    featureChange('Laitehallinta', 'Laitteen unohtaminen on nyt aina sallittua.'),
    bugfix(
      'Lähiliikenteen energiatehokkuudet',
      'Useammalle vuorolle näkyy nyt energiatehokkuudet.'
    ),
  ]),
  version('6.0.0-beta-3', '2025-08-18T14:30:00', [
    featureChange('Versiohistoria', 'Parannettu versiohistorian toimintaa.'),
  ]),
  version('5.21.0-beta-4', '2025-08-06T18:30:00', [
    bugfix(
      'Energiatehokkuuden haastot',
      'Korjattu parit energiatehokkuuksien haastoon liittyneet bugit'
    ),
  ]),
  version('5.20.0-beta-2', '2025-06-24T10:45:00', [
    newFeature(
      'Energiatehokkuuden haastot',
      'Lisätty mahdollisuus jättää kommentteja energiatehokkuuksiin liittyen'
    ),
  ]),
  version('5.19.0-beta-5', '2025-06-06T14:00:00', [
    featureChange(
      'Työvuoroluettelo',
      'Tasoitusvapaat, sekä X-, Y- ja Z-päivät näkyvät työvuoroluettelossa'
    ),
  ]),
  version('5.19.0-beta-2', '2025-05-28T16:30:00', [
    featureChange(
      'Junan kiertotiedot',
      'Näytetään tehtäväkortilla kaikkien eri osien kiertotiedot '
    ),
  ]),
  version('5.18.0-beta-2', '2025-05-13T11:00:00', [
    featureChange(
      'Henkilönumeron assumointi',
      'Muutettu henkilönumeron assumointia niin, että vain henkilönumeron mukaiseen rooliin liitetty data palautuu.'
    ),
    featureChange(
      'Elppari- ja KOTA-lokaatioiden päivitykset',
      'Muutettu elppari- ja KOTA-lokaatiotietojen päivitys pollausperusteiseksi, push-notifikaatioiden sijaan.'
    ),
    bugfix(
      'Työvuorojen kokoonpanohaku',
      'Korjattu työvuorojen kokoonpanuhaku tapahtumaan junan operointipäivän, eikä tehtävän päivämäärän mukaan.'
    ),
    bugfix(
      'Junien kulkupäivien Mylly-haku',
      'Korjattu junien kulkupäivien haku tapahtumaan vain valideilla junanumeroilla.'
    ),
  ]),
  version('5.15.0-beta-4', '2025-03-07T14:42:00', [
    bugfix('laitehallinta', 'Laitehallinta sivun kosmeettisia korjauksia'),
  ]),
  version('5.15.0-beta-1', '2024-02-27T16:50:00', [
    newFeature(
      'laitehallinta',
      'laitehallinta sivu/näkymä, laitehallintaan liittyvät etusivun notifikaatiot'
    ),
  ]),
  version('5.14.0-beta-1', '2025-01-31T14:00:00', [
    newFeature('Vikailmoittaminen', 'Siivousviat'),
    newFeature('Vikailmoittaminen', 'Sijaintien valinta littera- ja vikakoodikohtaisesti'),
    newFeature('Vikailmoittaminen', 'Vikailmoitukset lähijunille ja tavaravaunuille'),
  ]),
  version('5.7.0-beta-6', '2024-09-12T14:00:00', [
    newFeature(
      'Kaukoliikenteen työvuorot',
      'Kaukoliikenteen työvuorot näyttävät vahvat vapaat ja heittopäivät. Myös ICS kalenterissa'
    ),
  ]),
  version('5.6.12', '2024-09-11T11:00:00', [
    bugfix(
      'Lähiliikenteen työvuorot',
      'Lähiliikenteen työvuoroilla ollut puuttuvia lähtöraiteita, korjattua taustajärjestelmän käsittelyä.'
    ),
    bugfix(
      'Ajotietotuloste',
      'Ajotietotulosteen latauksessa näkynyt virheellinen varoitusteksti Kuplan käytöstä. Teksti poistettu.'
    ),
    newFeature(
      'Yleinen',
      'Tekninen vienti, jolla ei ole vaikutusta tuotantoympäristössä. SM-liikenteen merkittävä häiriötilanne ja lähiliikenteen työvuorojen pseudonymisointi.'
    ),
  ]),
  version('5.7.0-beta-5', '2024-08-29T16:00:00', [
    featureChange('Lahiksen työvuorot', 'Lahiksen työvuorot näkyvät pseudonymisoituna devilla'),
  ]),
  version('5.6.3', '2024-06-19T10:00:00', [
    bugfix(
      'Liito-häiriöviestit',
      'Korjaus Liito-häiriöviestien lataamiseen; viestejä ladataan vasta kun käyttäjän henkilöryhmä on tiedossa.'
    ),
  ]),
  version('5.6.0', '2024-06-05T12:00:00', [
    newFeature(
      'Liito-häiriöviestit',
      'Liito-häiriöviestien näkyminen konduktöörien-pilottiryhmälle.'
    ),
  ]),
  version('5.5.5', '2024-03-25T09:00:00', [
    featureChange('Taustajärjestelmä', 'Optimointeja taustajärjeselmän tekemiin kyselyihin'),
    bugfix('Vikailmoittaminen', 'Korjaus tiedostojen lataamiseen'),
    bugfix('Veksi / Lähiveksi -ilmoitukset', 'Korjaus ilmoitusten näkymiseen'),
  ]),
  version('5.5.2', '2024-03-06T11:00:00', [
    bugfix('Huoltotyöt', 'Korjaus huoltokuljettajien roolin tunnistukseen'),
  ]),
  version('5.5.1', '2024-03-06T11:00:00', [
    bugfix('Henkilökuntahaku', 'Korjaus tietojen näyttöön'),
  ]),
  version('5.3.1', '2024-03-05T09:00:00', [
    featureChange(
      'Vikailmoittaminen',
      'Yksinkertaistettu vikailmoittamisen lomaketta, lisätty mahdollisuus ladata myös suljettuja vikoja'
    ),
    bugfix('Vikailmoittaminen', 'Korjaus vikojen statuksen käsittelyyn'),
    bugfix('Vikatiedot', 'Kriittisyysluokan 3 näkyminen oikein jos vialla on käyttörajoite'),
  ]),
  version('5.3.0-beta-2', '2023-02-19T16:00:00', [
    newFeature('Huoltotyöt', 'KEN-1030: Huoltokujettajille mahdollisuus tehdä pikkuhuoltoja'),
    featureChange(
      'Vikailmoittaminen',
      'KEN-1068: Parannuksia toiminnallisuuteen käyttäjäpalautteen pohjalta'
    ),
    bugfix('Vikailmoittaminen', 'KEN-1071: hyväksytty status käsitellään suljettuna statuksena'),
  ]),
  version('5.0.8-beta-1', '2023-11-02T12:00:00', [
    featureChange('Työvuorohaku', 'KEN-630: Lähiksen työvuorojen haku'),
  ]),
  version('4.14.0-beta-2', '2023-06-21T12:00:00', [
    featureChange('Työvuoropalaute', 'KEN-991: Palaute työvuorosta pois lähiksen kuljettajilta'),
    bugfix('Työvuoropalaute', 'KEN-992: eSälli palautteen antaminen, spinneri jää pyörimään'),
    bugfix(
      'Käyttörajoitteet',
      'KEN-1010: Käyttörajoitehaku ei toimi oikein jos kalustolla yli 30 rajoitetta'
    ),
    bugfix('Kalenteri', 'KEN-1017: Google kalenteriviennissä ongelmia'),
    featureChange('Yleinen', 'KEN-1018: Google Analytics poistaminen'),
  ]),
  version('4.13.0-beta-1', '2023-05-02T10:00:00', [
    newFeature(
      'Käyttöoikeudet',
      'KEN-1008: Logistiikan RO-kuljettajien ja vaihtotyönjohtajien eriyttäminen omalle roolilleen'
    ),
    bugfix('Käyttöoikeudet', 'KEN-994: Kentän frontin sessiovanhenemisen parantaminen'),
    bugfix('Energiatehokkuus', 'KEN-1011: Energiatehokkuuden korjaukset'),
  ]),
  version('4.12.0-beta-1', '2023-04-17T12:00:00', [
    newFeature('Ajoympäristö', 'KEN-1002: Luotu uusi Kenttä ajoympäristö'),
  ]),
]

export default changelog_dev
